namespace $ {

	$mol_style_define( $bog_ui_app_sheet, {

		padding: $mol_gap.block,

		Description: {
			color: $mol_theme.shade,
			padding: {
				bottom: '1rem',
			},
		},

		Buttons_title: {
			font: {
				size: '1.125rem',
				weight: 'bold',
			},
			padding: {
				top: '.5rem',
				bottom: '.75rem',
			},
		},

		Buttons: {
			display: 'flex',
			gap: '.75rem',
			flex: {
				wrap: 'wrap',
			},
			padding: {
				bottom: '1rem',
			},
		},

		Top_content: {
			padding: $mol_gap.block,
		},

		Right_content: {
			padding: $mol_gap.block,
		},

		Bottom_content: {
			padding: $mol_gap.block,
		},

		Left_content: {
			padding: $mol_gap.block,
		},

		Top_heading: {
			font: {
				size: '1.25rem',
				weight: 'bold',
			},
			padding: {
				bottom: '.5rem',
			},
		},

		Right_heading: {
			font: {
				size: '1.25rem',
				weight: 'bold',
			},
			padding: {
				bottom: '.5rem',
			},
		},

		Bottom_heading: {
			font: {
				size: '1.25rem',
				weight: 'bold',
			},
			padding: {
				bottom: '.5rem',
			},
		},

		Left_heading: {
			font: {
				size: '1.25rem',
				weight: 'bold',
			},
			padding: {
				bottom: '.5rem',
			},
		},

		Top_text: {
			color: $mol_theme.shade,
			padding: {
				bottom: '1rem',
			},
		},

		Right_text: {
			color: $mol_theme.shade,
			padding: {
				bottom: '1rem',
			},
		},

		Bottom_text: {
			color: $mol_theme.shade,
			padding: {
				bottom: '1rem',
			},
		},

		Left_text: {
			color: $mol_theme.shade,
			padding: {
				bottom: '1rem',
			},
		},

		Right_form_title: {
			font: {
				weight: 'bold',
			},
			padding: {
				bottom: '.5rem',
			},
		},

		Right_name: {
			padding: {
				bottom: '.5rem',
			},
		},

	} )

}
